import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatTreeModule } from '@angular/material/tree';
import {
	OWL_DATE_TIME_LOCALE,
	OwlDateTimeIntl,
	OwlDateTimeModule,
	OwlNativeDateTimeModule,
} from 'ng-pick-datetime';
import { VerticalTabContentDirective } from 'src/app/components/vertical-tabs/vertical-tab-content.directive';
import { VerticalTabsComponent } from 'src/app/components/vertical-tabs/vertical-tabs.component';
import { HasPermissionDirective } from 'src/app/directives/has-permission.directive';
import { DateTimePipe } from 'src/app/pipes/dateTime.pipe';
import { DeleteHtmlLabelPipe } from 'src/app/pipes/deleteHtmlLabel';
import { TruncatePipe } from 'src/app/pipes/truncate.pipe';
import { UserSubTypePipe } from 'src/app/pipes/userSubType.pipe';
import { UserTypePipe } from 'src/app/pipes/userType.pipe';
import { ActionButtonsComponent } from 'src/app/shared/components/action-buttons/action-buttons.component';
import { TableLoadingOverlayComponent } from 'src/app/shared/components/table-loading-overlay/table-loading-overlay.component';
import { FileInputComponent } from '../../components/file-input/file-input.component';
import { ListItemComponent } from '../../components/list-item/list-item.component';
import { NewResourceComponent } from '../../components/new-resource/new-resource.component';
import { ResourceAutocompleteComponent } from '../../components/resource-autocomplete/resource-autocomplete.component';
import { SelectAutocompleteComponent } from '../../components/select-autocomplete/select-autocomplete.component';
import { SelectableTableComponent } from '../../components/selectable-table/selectable-table.component';
import { TreeComponent } from '../../components/tree/tree.component';
import { MaterialModule } from '../../material.module';
import { EnumValuePipe } from '../../pipes/enumValue.pipe';
import { StatusColorPipe } from '../../pipes/statuscolor.pipe';
import { WidgetEstadisticoComponent } from '../dashboard/components/widget/widget-estadistico/widget-estadistico.component';
import { CommentsComponent } from '../institutional-resume/pages/educational-project/components/comments/comments.component';
import { SendPeiComponent } from '../institutional-resume/pages/educational-project/components/send-pei/send-pei.component';
import { FileHistoryTableComponent } from './components/file-history-table/file-history-table.component';
import { FileDroppedComponent } from './components/fileDropped/file-dropped.component';
import { InfoModalComponent } from './components/info-modal/info-modal.component';
import { TagManagerComponent } from './components/tag-manager/tag-manager.component';
import { TextDiffComponent } from './components/text-diff/text-diff.component';
import { DndDirective } from './directives/dnd.directive';

export class DefaultIntl extends OwlDateTimeIntl {
	/** A label for the cancel button */
	override cancelBtnLabel = 'Cancelar';

	/** A label for the set button */
	override setBtnLabel = 'Aceptar';

	/** A label for the range 'from' in picker info */
	override rangeFromLabel = 'Desde';

	/** A label for the range 'to' in picker info */
	override rangeToLabel = 'Hasta';

	/** A label for the hour12 button (AM) */
	override hour12AMLabel = 'AM';

	/** A label for the hour12 button (PM) */
	override hour12PMLabel = 'PM';
}

@NgModule({
	declarations: [
		DateTimePipe,
		StatusColorPipe,
		EnumValuePipe,
		ListItemComponent,
		SelectableTableComponent,
		FileInputComponent,
		WidgetEstadisticoComponent,
		NewResourceComponent,
		ResourceAutocompleteComponent,
		SelectAutocompleteComponent,
		TreeComponent,
		FileDroppedComponent,
		DndDirective,
		TagManagerComponent,
		TextDiffComponent,
		InfoModalComponent,
		FileHistoryTableComponent,
		SendPeiComponent,
		CommentsComponent,
		DeleteHtmlLabelPipe,
		TruncatePipe,
		VerticalTabsComponent,
		VerticalTabContentDirective,
		ActionButtonsComponent,
		UserTypePipe,
		UserSubTypePipe,
		HasPermissionDirective,
		TableLoadingOverlayComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		FormsModule,
		ReactiveFormsModule,
		MatChipsModule,
		MatTreeModule
	],
	exports: [
		MaterialModule,
		DateTimePipe,
		StatusColorPipe,
		EnumValuePipe,
		ListItemComponent,
		SelectableTableComponent,
		FileInputComponent,
		WidgetEstadisticoComponent,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		NewResourceComponent,
		FormsModule,
		ReactiveFormsModule,
		ResourceAutocompleteComponent,
		SelectAutocompleteComponent,
		TreeComponent,
		FileDroppedComponent,
		DndDirective,
		TagManagerComponent,
		TextDiffComponent,
		InfoModalComponent,
		FileHistoryTableComponent,
		SendPeiComponent,
		CommentsComponent,
		DeleteHtmlLabelPipe,
		TruncatePipe,
		VerticalTabsComponent,
		VerticalTabContentDirective,
		ActionButtonsComponent,
		UserTypePipe,
		UserSubTypePipe,
		MatTreeModule,
		HasPermissionDirective,
		TableLoadingOverlayComponent
	],
	providers: [
		{ provide: OWL_DATE_TIME_LOCALE, useValue: 'es' },
		{ provide: OwlDateTimeIntl, useClass: DefaultIntl },
	],
})
export class SharedModule {}
